import { Instance, Promize, Table } from '@siposdani87/sui-js';
import { app } from '../app';
import { CategoryService } from '@services/categoryService';
import { LanguageService } from '@services/languageService';
import { initTable } from '@utils/collectionSetup';
import { DashboardController } from './dashboardController';

export class CategoriesIndexController extends DashboardController {
    static readonly inject = [
        'instances',
        'categoryService',
        'languageService',
    ] as const;

    organizationId!: string;
    categoriesTable!: Table;

    constructor(
        instances: Instance,
        private categoryService: CategoryService,
        private languageService: LanguageService,
    ) {
        super(instances);
    }

    protected override _initLayout(): void {
        this.organizationId = this.state.getParam('organizationId');

        this._initToolbarButtons();
        this._initFilterForm();

        this._drawContent();
    }

    protected override _drawContent(): Promize | boolean {
        this._initCategoryTable();
        return true;
    }

    private _initToolbarButtons(): void {
        this.helper.fabButton('.btn-categories-new', this.dom, () => {
            this.categoryService
                .newDialogByOrganization(this.organizationId)
                .then(() => {
                    this._drawContent();
                });
        });

        this.helper.iconButton('.btn-budgets-show', this.dom, () => {
            this.state.goBack('budgets.index');
        });
    }

    private _initCategoryTable(): void {
        this.categoriesTable = initTable(
            this.categoriesTable,
            this.dom,
            '.categories-table',
            this.categoryService,
            {
                entityKey: 'categories',
                fetchData: (params) =>
                    this.categoryService.getAllByOrganization(
                        this.organizationId,
                        params,
                    ),
                extraParams: (params) => params.set('query', this.query),
            },
            [
                {
                    style: () => [
                        'edit',
                        this.languageService.translate('buttons.edit'),
                    ],
                    click: (category) => {
                        this.categoryService
                            .editDialog(category)
                            .then(() => {
                                this._drawContent();
                            });
                    },
                },
            ],
        )!;
    }
}

export const categoriesIndexController = app.controller(
    'categoriesIndexController',
    CategoriesIndexController,
);
